<h5 *ngIf="title">{{ title }}</h5>
<form [formGroup]="form" (submit)="onSubmit($event)" class="align-items-end">
  <div class="row no-gutters">
    <div class="col">
      <div class="form-group">
        <label class="form-control-label" [for]="valueToUpdate">{{
          leftFieldlabel
        }}</label>
        <input
          type="number"
          class="form-control"
          [placeholder]="leftFieldPlaceholder"
          [id]="valueToUpdate"
          [formControl]="value"
        />
      </div>

      <div
        class="form-control-feedback text-danger"
        *ngIf="value.invalid && (value.dirty || value.touched)"
      >
        <span *ngIf="value.hasError('required')">{{
          validationMessages.required
        }}</span>
        <span *ngIf="value.hasError('max')">{{
          validationMessages.maxValue
        }}</span>
        <span *ngIf="value.hasError('min')">{{
          validationMessages.minValue
        }}</span>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label class="form-control-label" [for]="'order-id-' + valueToUpdate"
          >Order number *</label
        >
        <input
          type="text"
          class="form-control"
          placeholder="Order number (16 alphanumeric characters)"
          maxLength="17"
          [id]="'order-id-' + valueToUpdate"
          [formControl]="orderId"
        />
        <div
          class="form-control-feedback text-danger"
          *ngIf="orderId.invalid && (orderId.dirty || orderId.touched)"
        >
          <span *ngIf="orderId.hasError('required')">
            Order number is required
          </span>
          <span *ngIf="orderId.hasError('pattern')">
            Order number is invalid. It should have 16 alphanumeric characters
          </span>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <div></div>
        <app-button
          bsClass="primary"
          buttonType="submit"
          [disabled]="disabledSubmit"
          [tooltip]="!canPlaceOrders ? buttonTooltip : ''"
          [labeled]="true"
          [showLoader]="isUpdatingInput"
        >
          Save changes
        </app-button>
      </div>
    </div>
  </div>
</form>
